"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompanyUserGroups = exports.defaultParams = void 0;
var React = require("react");
var react_redux_1 = require("react-redux");
var recompose_1 = require("recompose");
var sok_ui_1 = require("@caddigital/sok-ui");
var Icon_1 = require("components/Icon");
var userGroupsActions = require("@caddigital/sok-reducers/lib/actions/customer/userGroups");
var userSettingsActions = require("@caddigital/sok-reducers/lib/actions/user/userSettings");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var MemberList_1 = require("components/MemberList");
var ConfirmDialog_1 = require("components/modals/ConfirmDialog");
var CreateEditModal_1 = require("./CreateEditModal");
var MoveUserToGroupModal_1 = require("./MoveUserToGroupModal");
var acl = require("@caddigital/sok-reducers/lib/utils/acl");
var InviteCustomerGroup_1 = require("./InviteCustomerGroup");
exports.defaultParams = {
    orderBy: 'user',
    order: 'asc'
};
var mapStateToProps = function (state) {
    return {
        region: state.customer.region,
        currentUser: state.auth.current.user,
        userGroups: state.customer.userGroups
    };
};
var mapDispatchToProps = function (dispatch) { return ({
    fetch: function (customerId) {
        return dispatch(userGroupsActions.UsergroupList.fetchRequest('CUSTOMER_USER_GROUPS', customerId));
    },
    inviteToggleModal: function () {
        return dispatch(userGroupsActions.UsergroupInvite.inviteToggleModal());
    },
    openUserSettingsModal: function (user, customerId, level) {
        return dispatch(userSettingsActions.openUserSettingsModal(user, level !== 'NormalUserGroup' ? 'ADMIN' : 'USER', [
            userGroupsActions.UsergroupList.fetchRequest('CUSTOMER_USER_GROUPS', customerId)
        ]));
    },
    setGroupsSelected: function (items, selected) {
        return dispatch(userGroupsActions.UsergroupList.setGroupsSelected(items, selected));
    },
    setUsersSelected: function (items, selected) {
        return dispatch(userGroupsActions.UsergroupList.setUsersSelected(items, selected));
    },
    setSortingSelector: function (sortBy) {
        dispatch(userGroupsActions.UsergroupList.setSortingSelector(sortBy));
    },
    collapseUserRow: function (id, isCollapsed) {
        return dispatch(userGroupsActions.UsergroupList.collapseUserRow(id, isCollapsed));
    },
    openUserProfileModal: function (mode, type, group) { return dispatch(userGroupsActions.createEditGroupModal(mode, type, group)); },
    deleteGroup: function (customerId, group) {
        return dispatch(userGroupsActions.removeGroupRequest(customerId, group));
    },
    deleteUser: function (customerId, items) { return dispatch(userGroupsActions.removeUserRequest(customerId, items)); },
    setFilter: function (filter, value) {
        return dispatch(userGroupsActions.UsergroupList.setColumnFilter(filter, value));
    },
    toggleMoveModal: function () { return dispatch(userGroupsActions.toggleMoveUserModal()); },
    moveUser: function (customerId) {
        return function (target, users) {
            return dispatch(userGroupsActions.moveUserRequest(customerId, target, users));
        };
    },
    clear: function () { return dispatch(userGroupsActions.clearState()); }
}); };
var enhance = (0, recompose_1.compose)((0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps), (0, recompose_1.withState)('searchString', 'setSearchString', ''), (0, recompose_1.withState)('warningModal', 'setWarningModal', null), (0, recompose_1.lifecycle)({
    componentDidMount: function () {
        this.props.fetch(this.props.currentCustomer.id);
    },
    componentWillUnmount: function () {
        this.props.clear();
    }
}), recompose_1.pure);
var searchEnhance = (0, recompose_1.compose)((0, recompose_1.withState)('tempSearchString', 'setTempSearchString', null), recompose_1.pure);
var onChangeTimeout = undefined;
var SearchBox = searchEnhance(function (props) { return (React.createElement("div", { className: 'search-container' },
    React.createElement(sok_ui_1.TextInput, { value: props.tempSearchString !== null ? props.tempSearchString : props.value, onChange: function (e) {
            var val = e.target.value;
            props.setTempSearchString(val);
            if (onChangeTimeout) {
                clearTimeout(onChangeTimeout);
            }
            onChangeTimeout = setTimeout(function () {
                props.setSearchString(val);
                props.setTempSearchString(null);
            }, 500);
        }, icon: React.createElement(Icon_1.Icon, { className: 'fa-search' }), iconRight: props.value ? (React.createElement("div", { className: 'search-box-right' },
            React.createElement(Icon_1.Icon, { className: 'fa-times', onClick: function () {
                    props.setSearchString('');
                    props.setTempSearchString(null);
                } }))) : undefined, placeholder: (0, translation_1.getLocalization)('management/customerGroups/searchPlaceholder') }))); });
exports.CompanyUserGroups = enhance(function (props) {
    return (React.createElement("div", { className: 'customer-user-groups' },
        React.createElement(sok_ui_1.RequestStatusBox, { status: props.userGroups.moveUserStatus, statusList: ['STANDBY', 'FETCHING', 'FETCHED', 'FAILED'] },
            (0, translation_1.getLocalization)('management/customerGroups/move/user/saving'),
            (0, translation_1.getLocalization)('management/customerGroups/move/user/saved'),
            (0, translation_1.getLocalization)('management/customerGroups/move/user/failed')),
        React.createElement(sok_ui_1.RequestStatusBox, { status: props.userGroups.removeGroupStatus, statusList: ['STANDBY', 'FETCHING', 'FETCHED', 'FAILED'] },
            (0, translation_1.getLocalization)('management/customerGroups/remove/group/saving'),
            (0, translation_1.getLocalization)('management/customerGroups/remove/group/saved'),
            (0, translation_1.getLocalization)('management/customerGroups/remove/group/failed')),
        React.createElement(sok_ui_1.RequestStatusBox, { status: props.userGroups.removeUserStatus, statusList: ['STANDBY', 'FETCHING', 'FETCHED', 'FAILED'] },
            (0, translation_1.getLocalization)('management/customerGroups/remove/user/saving'),
            (0, translation_1.getLocalization)('management/customerGroups/remove/user/saved'),
            (0, translation_1.getLocalization)('management/customerGroups/remove/user/failed')),
        React.createElement("div", { className: 'buttons' },
            React.createElement(sok_ui_1.Button, { disabled: props.userGroups.groups.length === 0, iconRight: React.createElement(Icon_1.Icon, { key: 'invite-icon', className: 'fa-user-plus' }), onClick: props.inviteToggleModal, size: 'large', color: 'green', className: 'text-left', text: (0, translation_1.getLocalization)('management/customerGroups/addMember') }),
            React.createElement(sok_ui_1.Dropdown2, null,
                React.createElement(sok_ui_1.Button, { icon: React.createElement(Icon_1.Icon, { key: 'add-icon', className: 'fa-plus-circle' }), iconRight: React.createElement(Icon_1.Icon, { className: 'fa-chevron-down' }), size: 'large', color: 'dark-gray', className: 'text-left', text: (0, translation_1.getLocalization)('management/customerGroups/addNew') }),
                React.createElement(sok_ui_1.Dropdown2Menu, null,
                    React.createElement(sok_ui_1.Dropdown2MenuItem, { onClick: function () {
                            return props.openUserProfileModal('CREATE', 'ARCHIVE_CATEGORY');
                        } }, (0, translation_1.getLocalization)('management/customerGroups/addArchivedCategory')),
                    React.createElement(sok_ui_1.Dropdown2MenuItem, { onClick: function () {
                            return props.openUserProfileModal('CREATE', 'ARCHIVE_USER_PROFILE');
                        } }, (0, translation_1.getLocalization)('management/customerGroups/addArchivedProfile')))),
            React.createElement(sok_ui_1.Button, { disabled: props.userGroups.selectedUsers.length === 0, iconRight: React.createElement(Icon_1.Icon, { key: 'remove-icon', className: 'fa-arrows-alt' }), size: 'large', color: 'green', className: 'text-left', text: (0, translation_1.getLocalization)('management/customerGroups/move'), onClick: function () { return props.toggleMoveModal(); } }),
            React.createElement(sok_ui_1.Button, { disabled: props.userGroups.selectedUsers.length === 0, iconRight: React.createElement(Icon_1.Icon, { key: 'remove-icon', className: 'fa-trash-alt' }), size: 'large', color: 'red', className: 'text-left', text: (0, translation_1.getLocalization)('management/customerGroups/remove'), onClick: function () {
                    props.setWarningModal({
                        title: (0, translation_1.getLocalization)('management/customerGroups/confirmDelete'),
                        content: [
                            (0, translation_1.getLocalization)('management/customerGroups/confirmDeleteSelected')
                        ],
                        action: function () {
                            return props.deleteUser(props.currentCustomer.id, props.userGroups.selectedUsers);
                        }
                    });
                } }),
            React.createElement(SearchBox, { setSearchString: props.setSearchString, value: props.searchString })),
        React.createElement(MemberList_1.MemberList, { translationKeys: {
                notFound: {
                    title: 'management/customerGroups/placeHolderTitle',
                    description: 'management/customerGroups/placeHolderDescription',
                    help: 'management/customerGroups/placeHolderHelp'
                }
            }, groups: props.userGroups.groups, searchString: props.searchString, isCollapsed: props.userGroups.isCollapsed, selectedUsers: props.userGroups.selectedUsers, selectedGroups: props.userGroups.selectedGroups, status: props.userGroups.status, sortingAndPagination: props.userGroups.sortingAndPagination, permission: acl.CUSTOMER_ADMIN_GRANT, fetch: function () { return props.fetch(props.currentCustomer.id); }, setUsersSelected: props.setUsersSelected, setGroupsSelected: props.setGroupsSelected, collapseUserRow: props.collapseUserRow, setWarningModal: props.setWarningModal, openUserSettingsModal: function (user) {
                return props.openUserSettingsModal(user, props.currentCustomer.id, props.currentUser.fold('NormalUserGroup', function (x) { return x.level; }));
            }, setSortingSelector: props.setSortingSelector, setFilter: props.setFilter, editGroup: function (group) {
                var type = 'NONE';
                if (group.type === 'CustomerCategoryUserGroup') {
                    if (group.archive) {
                        type = 'ARCHIVE_CATEGORY';
                    }
                    else {
                        type = 'CATEGORY';
                    }
                }
                else if (group.type === 'CustomerUserGroup') {
                    if (group.archive) {
                        type = 'ARCHIVE_USER_PROFILE';
                    }
                    else {
                        type = 'USER_PROFILE';
                    }
                }
                props.openUserProfileModal('EDIT', type, group);
            }, deleteGroup: function (group) {
                return props.deleteGroup(props.currentCustomer.id, group);
            }, deleteUsers: function (group, user) {
                return props.deleteUser(props.currentCustomer.id, [{ group: group, user: user }]);
            } }),
        React.createElement(CreateEditModal_1.default, { customerId: props.currentCustomer.id }),
        React.createElement(InviteCustomerGroup_1.default, { customerId: props.currentCustomer.id }),
        React.createElement(MoveUserToGroupModal_1.default, { isOpen: props.userGroups.moveUserModal, status: props.userGroups.moveUserStatus, groups: props.userGroups.groups, users: props.userGroups.selectedUsers, onSave: props.moveUser(props.currentCustomer.id), onUserRemove: function (item) { return props.setUsersSelected([item], false); }, onClose: props.toggleMoveModal }),
        React.createElement(ConfirmDialog_1.ConfirmDialog, { overlayClassName: 'generic-warning-confirmation-modal', isOpen: props.warningModal !== null, close: function () { return props.setWarningModal(null); }, header: props.warningModal
                ? props.warningModal.title
                : (0, translation_1.getLocalization)('genericWarningConfirmationModal/warning'), body: React.createElement(React.Fragment, null,
                React.createElement(ConfirmDialog_1.Exclamation, null),
                React.createElement("div", null,
                    React.createElement("div", { className: 'title please-confirm-text' },
                        React.createElement("h2", { className: "title" }, (0, translation_1.getLocalization)('genericWarningConfirmationModal/pleaseConfirm'))),
                    React.createElement("div", { className: 'text' }, ((props.warningModal && props.warningModal.content) || []).map(function (x) { return (React.createElement("p", null, x)); })))), footer: React.createElement(React.Fragment, null,
                React.createElement(sok_ui_1.Button, { color: 'red', text: (0, translation_1.getLocalization)('genericWarningConfirmationModal/confirm'), onClick: function () {
                        if (props.warningModal) {
                            props.warningModal.action();
                            props.setWarningModal(null);
                        }
                    } }),
                React.createElement(sok_ui_1.Button, { color: 'dark-gray', text: (0, translation_1.getLocalization)('genericWarningConfirmationModal/cancel'), onClick: function () { return props.setWarningModal(null); } })) })));
});
